import axios from 'axios';
import { IGlobalSync } from '../../../types';
import FlowyGlobal from '../../flowy-global';
import { gnov, snov } from '../../../utils';

interface IParams {
  fidsToDownload?: string[];
  fidsToRemove?: string[];
  sync: IGlobalSync;
  global: FlowyGlobal;
}

/**
 * Download root gizmo configurations from the server and save them to the database
 *
 * @param {string[]} fidsToDownload list of root gizmo fids to download
 * @param {IGlobalSync} sync sync object
 * @param {FlowyGlobal} global global instance
 */
async function downloadRootGizmos({
  fidsToDownload,
  fidsToRemove,
  sync,
  global,
}: IParams) {
  const apiUrl = global.getApiUrl();
  const user = await global.getPlatformInterface()?.getUser();
  const database = global.getDatabase();

  if (user?.credentials && database) {
    const credentials: any = user.credentials;
    const total: number = gnov(sync, 'progressBar.total');
    let progress: number = gnov(sync, 'progressBar.progress');

    if (fidsToDownload && Array.isArray(fidsToDownload)) {
      for (const rootGizmoFid of fidsToDownload) {
        const url = `${apiUrl}/main_api/v1/root_gizmo/${rootGizmoFid}`;
        const headers = { ...credentials };

        try {
          const response = await axios.get(url, { headers });

          if (response.status === 200) {
            const { forms } = response.data;

            if (forms && Array.isArray(forms) && forms.length > 0) {
              if (database) {
                for (const form of forms) {
                  await database.set({
                    type: 'forms',
                    value: form,
                    update: true,
                  });
                }

                if (progress <= total) {
                  progress += 1;

                  snov(sync, 'progressBar', { total, progress });

                  global.setSync(sync);
                }
              }
            }
          }
        } catch (e) {
          // TODO: handle download error
        }
      }
    }

    if (fidsToRemove && Array.isArray(fidsToRemove)) {
      for (const rootGizmoFid of fidsToRemove) {
        try {
          await database.delete({
            type: 'forms',
            fid: rootGizmoFid,
          });
        } catch (e) {}
      }
    }
  }
}

export default downloadRootGizmos;
